(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    function initializeCCSSpeciesMenus() {
 document.querySelectorAll('.ccs-hover-menu').forEach((menu) => {
  if (menu.dataset.ccsBound) return;
  menu.dataset.ccsBound = 'true';
  const details = menu.querySelector('details');
  let closeTimer;
  menu.addEventListener('pointerenter', (event) => {
   if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 990px)').matches) return;
   clearTimeout(closeTimer);
   document.querySelectorAll('.ccs-hover-menu details[open]').forEach((other) => { if (other !== details) other.open = false; });
   details.open = true;
  });
  menu.addEventListener('pointerleave', (event) => {
   if (event.pointerType !== 'mouse') return;
   closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) details.open = false; }, 160);
  });
 });
}
initializeCCSSpeciesMenus();
document.addEventListener('shopify:section:load', initializeCCSSpeciesMenus);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["summer-sale-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initPopup = () => {
      const storageKey = 'ccsWalkEssentialsPopupShownV1';
      const overlay = document.getElementById('ccs-walk-popup-overlay');
      if (!overlay || sessionStorage.getItem(storageKey)) return;

      const closeButton = overlay.querySelector('.ccs-ssp-close');
      let previousOverflow = '';
      let previousFocus = null;

      const openPopup = () => {
        previousFocus = document.activeElement;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        overlay.classList.add('is-visible');
        overlay.setAttribute('aria-hidden', 'false');
        sessionStorage.setItem(storageKey, '1');
        closeButton.focus();
      };

      const closePopup = () => {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = previousOverflow;
        if (previousFocus instanceof HTMLElement) previousFocus.focus();
      };

      window.setTimeout(openPopup, 2500);

      closeButton.addEventListener('click', closePopup);
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) closePopup();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && overlay.classList.contains('is-visible')) closePopup();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPopup, { once: true });
    } else {
      initPopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
